import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Button, ButtonContainer, Modal, ModalHeader, ModalFooter } from '@emburse/embark-core';
function Dialog({ title, show, showClose, confirmText, cancelText, onClose, color, onConfirm, content, hideBackdrop, disableConfirm, size }) {
    return (_jsx(Modal, { open: show, hideBackdrop: hideBackdrop, size: size ?? 'sm', modalHeader: _jsx(ModalHeader, { title: title, showClose: showClose, onCloseClicked: (event) => {
                if (onClose) {
                    onClose(event, 'headerClose');
                }
            } }), onClose: (event, reason) => {
            onClose(event, reason);
        }, modalFooter: _jsx(ModalFooter, { children: _jsxs(ButtonContainer, { alignButtons: "right", children: [_jsx(Button, { variant: "outlined", color: color, onClick: (event) => {
                            onClose(event, 'headerClose');
                        }, "data-qa": "cancel-dialog", children: cancelText }), _jsx(Button, { color: color, onClick: () => {
                            onConfirm();
                        }, disabled: disableConfirm, "data-qa": "confirm-dialog", children: confirmText })] }) }), children: content }));
}
Dialog.defaultProps = {
    title: 'Confirmation',
    showClose: true,
    cancelText: 'Cancel',
    confirmText: 'Confirm',
    color: 'primary',
    hideBackdrop: false,
    disableConfirm: false
};
export default Dialog;
